export default class User {
  constructor (phone, password) {
    this.phone = phone
    this.password = password
  }
}
